import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import dict from "../i18n/translations";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "nl";
    return localStorage.getItem("mp_lang") || "nl";
  });

  useEffect(() => {
    localStorage.setItem("mp_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (key, vars) => {
      const table = dict[lang] || dict.nl;
      let s = table[key] ?? dict.nl[key] ?? key;
      if (vars && typeof s === "string") {
        for (const k in vars) s = s.replace(`{${k}}`, vars[k]);
      }
      return s;
    },
    [lang]
  );

  const toggle = useCallback(() => setLang((l) => (l === "nl" ? "en" : "nl")), []);

  const value = useMemo(() => ({ lang, setLang, toggle, t }), [lang, toggle, t]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
